<template>
  <div class="enWarehouse">
    <div class="end_view">
    <h1 class="title">{{wareHouse.boxNo}}号箱格已关闭</h1>
    <div class="img_wrap">
      <img src="/static/images/scan.svg">
    </div>
    <h2 class="text">入库单号{{wareHouse.trackNum}}已投递</h2>
    <div class="bot_wrap">
      <div class="submit_btn btn" @click.stop="submitList">提交入库清单</div>
      <div class="keep_btn btn" @click.stop="deliverAgain">继续投递</div>
    </div>
  </div>
  </div>
</template>

<script>
var _this
import "../../../../static/CEsite/css/common.less"
export default {
  name: 'enWarehouseFinal',
  data() {
    return {
      actionType: '',
      // 上一页的数据
      wareHouse: {
        boxNo: '1',
        trackNum: '10086',
      }
    }
  },
  created() { // 由上一页（扫码页）获取单号和箱格号
    this.actionType = this.$route.query.actionType;
    this.wareHouse = this.$route.query.wareHouse;
    console.warn('完成页actionType：',this.actionType);
    console.log('用户选择的箱格数据',this.wareHouse);
  },
  mounted() {
    _this = this;
  },
  destroyed() {

  },
  methods: {
    // 提交入库清单
    submitList() {
      console.log('提交入库清单');
      _this.$router.push({
        path: '/eSite/enWarehouse/enWarehouseList',
        query: {actionType: _this.actionType}
      })
    },
    // 继续投递
    deliverAgain() {
      // console.log(this);
      _this.$router.push({
        path: '/eSite/enWarehouse',
        query: {actionType: _this.actionType}
      })
    },
    // 返回上一页
    toReturn() {
      _this.$router.go(-1);
    },
    // 退出登录,需要清除token
    toExit() {
      _this.$router.push({
        path: '/',
      })
    },
  },
}
</script>

<style lang="less">
.enWarehouse {
.end_view {
  width: 70%;
  position: absolute;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  .title {
    font-size: 0.8rem;
    margin-bottom: 0.2rem;
  }
  .img_wrap {
    width: 50%;
    height: 4rem;
    text-align: center;
    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
  h2.text {
    margin: 0.1rem 0;
    text-align: center;
    font-size: 0.5rem;
  }
  .bot_wrap {
    width: 65%;
    display: flex;
    text-align: center;
    margin-top: 0.2rem;
    justify-content: space-around;
    div {
      margin: 0;
      width: 2.10rem;
      height: 0.6rem;
      font-size: 0.3rem;
      text-align: center;
      line-height: 0.6rem;
      // padding: 0.1rem;
    }
    .submit_btn {
      float: left;
    }
    .keep_btn {
      float: right;
    }
  }
}
}
</style>





// WEBPACK FOOTER //
// src/components/CEsite/EN-warehouse/enWarehouseFinal.vue